import React, { FC } from "react";

import Template from "../../components/Template";

const TemplateListPage: FC = () => <Template/>;

export default TemplateListPage;
